export const licenseTypes = {
  types: ['enterprise', 'individual'],
  subTypes: ['trial', 'premium', 'university', 'gold'],
  products: ['pathways', 'toolkit']
}
